import {
    Button,
    ButtonGroup,
    FormHelperText,
    Grid,
    InputLabel,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    withStyles
} from '@material-ui/core';
import React, { useContext } from 'react';
import { DatePicker, SecondaryButton, SelectBox, TextBox } from '../../../../Core/FormInput';
import AppContext from '../../../../App/AppContext';
import DriveEtaTwoToneIcon from '@material-ui/icons/DriveEtaTwoTone';
import { ArrowDownwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import AddBoxIcon from '@material-ui/icons/AddBox';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import formatters from '../../../../Core/Grid/inputFormatter';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const StyledSubTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5,
        fontSize: 11,
        fontWeight: 600
    },
    body: {
        fontSize: 14,
        backgroundColor: 'white',
        borderBottom: '1px solid rgba(0,0,0,0.3)',
        padding: 5
    }
}))(TableCell);

const TCardModalsBody = ({
    handleChange,
    state,
    isReadonly,
    handleButtonStatusClick,
    classes,
    checkIsTcardReadonly,
    tCardItemList,
    handleSelectedLineEventStatusChange,
    selectedIndex,
    addRepairLine,
    editRowSelect,
    removeRepairLine,
    handleMoveClick,
    handleSubmit,
    onClose,
    btnLoader
}) => {
    const { portalSettings } = useContext(AppContext);
    const motLabel = portalSettings?.portalSettingsMOTText || 'MOT';
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={4} md={2}>
                <InputLabel shrink style={{ marginBottom: '0px' }}>
                    Branch
                </InputLabel>
                <SelectBox onChange={handleChange} value={state.tCardsBranchID} name="tCardsBranchID" List={state.branches || []} disabled={isReadonly} />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
                <InputLabel shrink style={{ marginBottom: '-9px' }} className={!state.tCardsStatusID == 0 ? 'mandatoryfields' : ''}>
                    Booking Date
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsBookingDate"
                    type="datetime-local"
                    value={state.tCardsBookingDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={isReadonly}
                />
                {(!state.tCardsStatusID == 0 || !state.tCardsStatusID == 15) && (
                    <FormHelperText style={{ color: 'red' }}>{state.errors['tCardsBookingDate']}</FormHelperText>
                )}
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
                <InputLabel shrink style={{ marginBottom: '-9px' }}>
                    Deadline Date
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsDeadlineDate"
                    type="datetime-local"
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    value={state.tCardsDeadlineDate}
                    disabled={isReadonly}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
                <InputLabel shrink style={{ marginBottom: '-9px' }}>
                    Due Date
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsDueDate"
                    type="datetime-local"
                    value={state.tCardsDueDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={isReadonly}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={1}>
                <InputLabel shrink style={{ marginBottom: '-9px' }}>
                    Mileage
                </InputLabel>
                <TextBox fullWidth name="tCardsMileage" value={state.tCardsMileage} onChange={handleChange} disabled={isReadonly} />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
                <InputLabel shrink style={{ marginBottom: '-9px' }}>
                    Argus Case Number
                </InputLabel>
                <TextBox fullWidth name="tCardArgusCaseNumber" value={state.tCardArgusCaseNumber} onChange={handleChange} disabled={isReadonly} />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
                <InputLabel shrink style={{ marginBottom: '-9px' }} error={state.tCardsPaymentTypeID == 1} required={state.tCardsPaymentTypeID == 1}>
                    Contact Name
                </InputLabel>
                <TextBox fullWidth name="tCardsContactName" value={state.tCardsContactName} onChange={handleChange} disabled={isReadonly} />
                <FormHelperText error>{state.errors['tCardsContactName']}</FormHelperText>
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
                <InputLabel shrink style={{ marginBottom: '-9px' }} error={state.tCardsPaymentTypeID == 1} required={state.tCardsPaymentTypeID == 1}>
                    Contact Number
                </InputLabel>
                <TextBox fullWidth name="tCardsContactNumber" value={state.tCardsContactNumber} onChange={handleChange} disabled={isReadonly} />
                <FormHelperText error>{state.errors['tCardsContactNumber']}</FormHelperText>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                <InputLabel shrink style={{ marginBottom: '-9px' }} className={state.orderNumberRequired ? 'mandatoryfields' : ''}>
                    Customer Order No
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsCustomerOrderNumber"
                    value={state.tCardsCustomerOrderNumber}
                    onChange={handleChange}
                    error={!!state.errors.tCardsCustomerOrderNumber}
                    disabled={isReadonly}
                />
                {state.errors.tCardsCustomerOrderNumber && <FormHelperText style={{ color: 'red' }}>{state.errors.tCardsCustomerOrderNumber}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={4} md={5}>
                <InputLabel
                    component="legend"
                    required={state.tCardsIsMOT}
                    className={state.tCardsIsMOT ? 'mandatoryfields' : ''}
                    shrink
                    style={{ marginBottom: '-9px' }}
                >
                    {motLabel} Location
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsMOTLocation"
                    value={state.tCardsMOTLocation}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={isReadonly}
                />

                {state.tCardsIsMOT && <FormHelperText style={{ color: 'red' }}>{state.errors['tCardsMOTLocation']}</FormHelperText>}
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
                <InputLabel
                    component="legend"
                    required={state.tCardsIsMOT}
                    shrink
                    style={{ marginBottom: '-9px' }}
                    className={state.tCardsIsMOT ? 'mandatoryfields' : ''}
                >
                    {motLabel} Date
                </InputLabel>
                <TextBox
                    fullWidth
                    name="tCardsMOTDate"
                    type="datetime-local"
                    value={state.tCardsMOTDate}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={isReadonly}
                />
                {state.tCardsIsMOT && (
                    <FormHelperText className={state.tCardsIsMOT ? 'mandatoryfields' : ''} style={{ color: 'red' }}>
                        {state.errors['tCardsMOTDate']}
                    </FormHelperText>
                )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
                <InputLabel shrink component="legend" style={{ marginBottom: '-9px' }}>
                    Priority
                </InputLabel>
                <SelectBox
                    style={{ marginBottom: '4px', marginTop: '8px' }}
                    fullWidth
                    name="tCardsPriorityID"
                    value={state.tCardsPriorityID}
                    onChange={handleChange}
                    List={state.tCardPrioritiesList || []}
                    disabled={isReadonly}
                />
            </Grid>
            <Grid item xs={12}>
                <div shrink style={{ marginBottom: '0px' }}>
                    Status
                </div>
                <ButtonGroup color="secondary" aria-label="outlined secondary button group">
                    {state.tCardsStatus.map((item, index) => (
                        <Button
                            style={{
                                fontSize: 10
                            }}
                            onClick={() => handleButtonStatusClick('tCardsStatusID', item.id)}
                            key={index}
                            variant={state.tCardsStatusID === item.id ? 'contained' : 'outlined'}
                            disabled={isReadonly}
                        >
                            {item.name}
                        </Button>
                    ))}
                </ButtonGroup>
            </Grid>
            <Grid item xs={12}>
                <TableContainer style={{ height: 250, border: '1px solid rgba(0,0,0,0.2)' }}>
                    <Table className={classes.table} size="small" stickyHeader>
                        <TableHead>
                            <TableRow className="header">
                                {!checkIsTcardReadonly && (
                                    <StyledSubTableCell width="12%">
                                        <AddBoxIcon
                                            onClick={addRepairLine}
                                            style={{ color: 'green', verticalAlign: 'middle', cursor: 'pointer', fontSize: 15 }}
                                        />
                                    </StyledSubTableCell>
                                )}
                                <StyledSubTableCell width="10%">Event Type</StyledSubTableCell>
                                {/* <StyledSubTableCell width="12%">Due Date</StyledSubTableCell> */}
                                <StyledSubTableCell
                                // width="45%"
                                >
                                    Description/Comments
                                </StyledSubTableCell>
                                <StyledSubTableCell width="5%">Allocated</StyledSubTableCell>
                                <StyledSubTableCell width="5%">Spent</StyledSubTableCell>
                                <StyledSubTableCell width="15%">Status</StyledSubTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tCardItemList.length > 0 &&
                                tCardItemList?.map((q, i) => {
                                    return (
                                        <TableRow key={i}>
                                            {!checkIsTcardReadonly && (
                                                <StyledSubTableCell style={{ borderBottom: '1px solid rgba(0,0,0,0.3)' }}>
                                                    <RemoveCircleIcon
                                                        onClick={() => removeRepairLine(i)}
                                                        fontSize="small"
                                                        style={{ color: 'red', cursor: 'pointer', fontSize: 15 }}
                                                    />
                                                    &nbsp; &nbsp;
                                                    {selectedIndex === i ? (
                                                        <CheckCircleIcon
                                                            onClick={() => editRowSelect(null)}
                                                            fontSize="small"
                                                            style={{ cursor: 'pointer', color: 'green', fontSize: 15 }}
                                                        />
                                                    ) : (
                                                        <EditIcon
                                                            onClick={() => editRowSelect(i)}
                                                            fontSize="small"
                                                            style={{ cursor: 'pointer', color: '#2964D9', fontSize: 15 }}
                                                        />
                                                    )}
                                                    {!q.isLocal && (
                                                        <>
                                                            {q.tCardsLineItemSequence != state.smallSequence && (
                                                                <Tooltip title="Up Sequence" aria-label="add">
                                                                    <ArrowUpwardRounded
                                                                        fontSize="small"
                                                                        color="action"
                                                                        onClick={() => handleMoveClick(q, 'up')}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                            {q.tCardsLineItemSequence != state.bigSequence && (
                                                                <Tooltip title="Down Sequence" aria-label="add">
                                                                    <ArrowDownwardRounded
                                                                        fontSize="small"
                                                                        color="action"
                                                                        onClick={() => handleMoveClick(q, 'down')}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                        </>
                                                    )}
                                                </StyledSubTableCell>
                                            )}
                                            <StyledSubTableCell>{q.event || '-'}</StyledSubTableCell>
                                            {/* <StyledSubTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <DatePicker
                                                            name="tCardsLineItemsDueDate"
                                                            value={formatters.DateFormatter(q.tCardsLineItemsDueDate)}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>{q.tCardsLineItemsDueDate ? formatters.MonthShortFormatter(q.tCardsLineItemsDueDate) : '-'}</div>
                                                )}
                                            </StyledSubTableCell> */}
                                            <StyledSubTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsDescription"
                                                            value={q.tCardsLineItemsDescription}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>{q.tCardsLineItemsDescription || '-'}</div>
                                                )}
                                            </StyledSubTableCell>
                                            <StyledSubTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsAllocatedHours"
                                                            value={q.tCardsLineItemsAllocatedHours}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div> {q.tCardsLineItemsAllocatedHours || '-'}</div>
                                                )}
                                            </StyledSubTableCell>
                                            <StyledSubTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -7 }}>
                                                        <TextBox
                                                            name="tCardsLineItemsSpentHours"
                                                            value={q.tCardsLineItemsSpentHours}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div> {q.tCardsLineItemsSpentHours}</div>
                                                )}
                                            </StyledSubTableCell>
                                            <StyledSubTableCell>
                                                {selectedIndex === i ? (
                                                    <div style={{ marginTop: -5 }}>
                                                        <SelectBox
                                                            fullWidth
                                                            name="tCardsLineItemsLineStatusID"
                                                            value={q.tCardsLineItemsLineStatusID}
                                                            onChange={(e) => handleSelectedLineEventStatusChange(e, i)}
                                                            List={state.tCardLineStatus || []}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div>{state.tCardLineStatus.find((k) => k.id === q.tCardsLineItemsLineStatusID)?.name || '-'}</div>
                                                )}
                                            </StyledSubTableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {!state.disabledUpdateButton && (
                <Grid item xs={6}>
                    <SecondaryButton fullWidth disabled={checkIsTcardReadonly} onClick={handleSubmit} isBtnLoader={btnLoader}>
                        Update
                    </SecondaryButton>
                </Grid>
            )}
            <Grid item xs={state.disabledUpdateButton ? 12 : 6}>
                <SecondaryButton fullWidth onClick={() => onClose(false, null, false)}>
                    cancel
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default TCardModalsBody;
